import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LatestFromBlog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/blog/posts?limit=3`);
        if (!cancelled) setPosts(res.data.slice(0, 3));
      } catch {
        if (!cancelled) setPosts([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch {
      return iso;
    }
  };

  if (loading || posts.length === 0) return null;

  return (
    <section className="latest-blog-section" data-testid="latest-from-blog">
      <div className="container">
        <div className="latest-blog-header">
          <h2 className="section-title">Latest from the Blog</h2>
          <p className="section-subtitle">Cat care tips, stories and advice from our visits</p>
        </div>

        <div className="latest-blog-grid">
          {posts.map((post) => (
            <article key={post.slug} className="latest-blog-card" data-testid={`latest-blog-card-${post.slug}`}>
              <Link to={`/blog/${post.slug}`} className="latest-blog-image-link">
                <img
                  src={post.coverImage}
                  alt={post.title}
                  className="latest-blog-image"
                  loading="lazy"
                />
              </Link>
              <div className="latest-blog-body">
                <span className="latest-blog-category">{post.category}</span>
                <h3 className="latest-blog-title">
                  <Link to={`/blog/${post.slug}`} data-testid={`latest-blog-link-${post.slug}`}>
                    {post.title}
                  </Link>
                </h3>
                <p className="latest-blog-excerpt">{post.excerpt}</p>
                <div className="latest-blog-meta">
                  <span>{formatDate(post.publishedAt)}</span>
                  <span aria-hidden="true">•</span>
                  <span>{post.readTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="latest-blog-cta">
          <Link to="/blog" className="latest-blog-view-all" data-testid="latest-blog-view-all">
            View all posts →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestFromBlog;
